import { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useToast } from '@/components/ui/use-toast';
import { useOrganizationContext } from '../organization.context';
import organizationApiPrivate from '@/api/organization.api.private';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogClose,
} from '@/components/ui/dialog';
import { FEATURES } from 'shared/constants/features.constants';
import { cn } from '@/lib/utils';

export default function HubShareAll() {
  const { organization } = useOrganizationContext();
  const [loading, setLoading] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const { toast } = useToast();

  const handleShareAllContent = async () => {
    setLoading(true);

    const { error } = await organizationApiPrivate.hubShareAll({ id: organization.id });

    setLoading(false);
    setDialogOpen(false);

    if (error) {
      toast({
        title: 'Error sharing content',
        description: `An error occurred while sharing all content to the hub error: ${error.message}`,
        variant: 'destructive',
      });
      return;
    }

    toast({
      title: 'All content has been shared to the hub',
    });
  };

  const disabled = !organization?.features?.includes(FEATURES.KNOWLEDGE_HUB_ACCESS);

  return (
    <Card className={cn(disabled && 'opacity-50 pointer-events-none')}>
      <CardHeader>
        <CardTitle>Bulk Share Content</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col gap-4">
          <p className="text-sm text-muted-foreground">
            Share all existing knowledge items from this organization to the Knowledge Hub. This
            action will make all content available in the hub.
          </p>

          <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
            <DialogTrigger asChild>
              <Button variant="outline" className="w-fit" disabled={disabled}>
                Share All Content to Hub
              </Button>
            </DialogTrigger>
            <DialogContent>
              <DialogHeader>
                <DialogTitle>Share All Content</DialogTitle>
                <DialogDescription>
                  Are you sure you want to share all existing content from this organization to the
                  Knowledge Hub? This will make all knowledge items publicly available in the hub
                  except of content that was unshared manually.
                </DialogDescription>
              </DialogHeader>
              <DialogFooter className="gap-2 sm:gap-0">
                <DialogClose asChild>
                  <Button variant="outline">Cancel</Button>
                </DialogClose>
                <Button onClick={handleShareAllContent} disabled={loading}>
                  {loading ? 'Sharing...' : 'Confirm Share All'}
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
        </div>
      </CardContent>
    </Card>
  );
}
